/**
 * 客訂 Detail `workOrderMtrs[]` → 扁平工單列（一筆 workOrder 一列）。
 * 僅展開 API 巢狀；製造標的＝父層 mtrNo/mtrName（非 CRM product）。
 * 透傳 `work_orders[].status`（後端合完即可用）；不另打工單 Detail。
 * 扁平後依 `workOrderNo` 升序（localeCompare；空號置後）。
 */

function compareWorkOrderNoAsc(a, b) {
  const aNo = String(a?.workOrderNo ?? '').trim();
  const bNo = String(b?.workOrderNo ?? '').trim();
  if (!aNo && !bNo) {
    return 0;
  }
  if (!aNo) {
    return 1;
  }
  if (!bNo) {
    return -1;
  }
  return aNo.localeCompare(bNo, 'zh-Hant', { numeric: true, sensitivity: 'base' });
}

/**
 * @param {object[]|null|undefined} workOrderMtrs
 * @returns {{
 *   id: string,
 *   workOrderId: string,
 *   workOrderNo: string,
 *   status: string,
 *   mtrId: string,
 *   mtrNo: string,
 *   mtrName: string,
 *   qty: number|string|null|undefined,
 * }[]}
 */
export function mapCustomerOrderWorkOrderRows(workOrderMtrs) {
  if (!Array.isArray(workOrderMtrs) || workOrderMtrs.length === 0) {
    return [];
  }

  const rows = [];
  workOrderMtrs.forEach((group, groupIndex) => {
    const mtrId = group?.mtrId ?? '';
    const mtrNo = group?.mtrNo ?? '';
    const mtrName = group?.mtrName ?? '';
    const workOrders = Array.isArray(group?.workOrders) ? group.workOrders : [];

    workOrders.forEach((wo, woIndex) => {
      const workOrderId = wo?.workOrderId ?? '';
      const workOrderNo = wo?.workOrderNo ?? '';
      rows.push({
        id: workOrderId || `wo-${groupIndex}-${woIndex}`,
        workOrderId,
        workOrderNo,
        status: wo?.status ?? '',
        mtrId,
        mtrNo,
        mtrName,
        qty: wo?.qty,
      });
    });
  });

  rows.sort(compareWorkOrderNoAsc);
  return rows;
}
